import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const MovieList = () => {
  let { id } = useParams();
  const [input, setInput] = useState({
    name:"", singlePlayer:"", multiplayer:"", platform:"", release:0, image_url:""
  });
  const [fetch, setFetch] = useState(true)
  // const [genre, setGenre] = useState("");
  // const [singlePlayer, setSinglePlayer] = useState(true);
  // const [multiplayer, setMultiplayer] = useState(true);
  // const [platform, setPlatform] = useState("");
  // const [release, setRelease] = useState("");
  // const [image_url, setImage_url] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(
        `https://backendexample.sanbersy.com/api/data-game/${id}`
      );
          const {
            name,
            genre,
            singlePlayer,
            multiplayer,
            platform,
            release,
            image_url
          } = result.data
          setInput ({
            name,
            genre,
            singlePlayer,
            multiplayer,
            platform,
            release,
            image_url,
          });
        }
     if(fetch){
        fetchData();
      setFetch(false)
    }
  }, [fetch]);
const Single = (singlePlayer, multiplayer) =>{
  if(singlePlayer === 1 || multiplayer === 1){
    return "singlePlayer multiplayer"
  } else if(singlePlayer === 1 || multiplayer === 0){
    return "SinglePlayer"
  }else if(singlePlayer === 0 || multiplayer === 1){
    return "MultiPlayer"
  }
  else {
    return "0"
  }
}

  return (
    <div className="container">
      <div style={{ display: "flex", backgroundColor:"#f0f2f5", marginTop:"0px", padding:" 40px 40px" }}>
        <img
          src={input.image_url}
          alt="image"
          style={{ height: "400px", width: "300px", marginTop: "20px" }}
        />
        <div style={{ marginLeft: "100px", marginTop:"40px" }}>
          <div>
            <h2>
              {input.name}({input.release})
            </h2>
          </div>
          <div>
            .{input.genre}
          </div>
          <h3>Platform</h3>
          <div>{input.platform}</div>
          <h2>Mode</h2>
          <div>{Single (input.singlePlayer)}</div>
        </div>
      </div>
    </div>
  );
};

export default MovieList;